import f1 from '@eab-pip/pi-f1';

export interface IPanelDimensions {
  column: number;
  height: number;
  width: number;
  row: number;
}

export interface IPanelCoordinates {
  x: number;
  y: number;
  w: number;
  h: number;
}

/**
 * compute dimensions (row, column, ) to coordinates for Grid Stack (x, y, )
 */
export class DashboardUtility {
  static dimensionsToCoordinates(dimensions: IPanelDimensions, columns: number): IPanelCoordinates {
    return {
      y: dimensions.column,
      h: dimensions.height,
      w: this.__computeCoordinate(dimensions.width, columns),
      x: this.__computeCoordinate(dimensions.row, columns)
    };
  }

  private static __computeCoordinate(dimension: number, columns: number) {
    // columns is 2
    // 6 -> 1
    // 12 -> 2

    // columns is 3
    // 4 -> 1
    // 8 -> 2
    // 12 -> 3

    // columns is 4
    // 3 -> 1
    // 6 -> 2
    // 9 -> 3
    // 12 -> 4
    return f1.to.integer(f1.safe(0, dimension) / f1.to.integer(12 / columns));
  }

  static coordinatesToDimensions(dimensions: IPanelCoordinates, columns: number): IPanelDimensions {
    return {
      column: dimensions.y,
      height: dimensions.h,
      width: this.__computeDimension(dimensions.w, columns),
      row: this.__computeDimension(dimensions.x, columns)
    };
  }

  private static __computeDimension(coordinate: number, columns: number) {
    return f1.to.integer(f1.safe(0, coordinate) * f1.to.integer(12 / columns));
  }

  static isEqual(_1: IPanelDimensions, _2: IPanelDimensions): boolean {
    return _1.row === _2.row && _1.column === _2.column && _1.width === _2.width && _1.height === _2.height;
  }
}
